import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=77fb1deb&"
import script from "./UploadedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFiles.vue?vue&type=style&index=0&id=77fb1deb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports